import React from 'react';
import BandcampFulfilmentsTable from './components/BandcampFulfilmentsTable';

const BandcampFulfilments = () => (
  <BandcampFulfilmentsTable />
);

export default BandcampFulfilments;
